<div
  data-slot="empty-title"
  class="empty-title"
  [ngClass]="className"
>
  <ng-content></ng-content>
</div>
